var map = {
	"./average_payoff_win_vs_loss_trade.png": 8678,
	"./break_after_loss_trade_per_trade.png": 7389,
	"./break_since_last_trade_per_trade.png": 3102,
	"./long_and_short_per_trade.png": 6286,
	"./max_risk_all_open_trades_last_trades.png": 5278,
	"./open_different_symbols_per_trade.png": 2387,
	"./open_position_in_profit_loss.png": 5270,
	"./percent_of_trades_stopped_early_in_profit.png": 2430,
	"./percentage_of_position_with_sl.png": 1771,
	"./profit_after_daily_profit_loss.png": 9767,
	"./profit_after_withdrawal_in_pips.png": 3331,
	"./profit_by_daytime_per_trade.png": 3029,
	"./profit_by_symbol_per_trade.png": 5986,
	"./profit_by_trade_length_per_trade.png": 4103,
	"./profit_by_weekday_per_trade.png": 9710,
	"./profit_for_trade_during_overbought_oversold.png": 1128,
	"./profit_high_vs_low_volatility.png": 9284,
	"./profit_if_adding_to_negative_positions.png": 7626,
	"./profit_if_manual_stop_before_tp.png": 9833,
	"./profit_if_publishing_trades.png": 4857,
	"./profit_if_sl_closer_further_away.png": 8851,
	"./profit_if_tp_closer_further_away.png": 9048,
	"./profit_if_trade_close_earlier_later.png": 786,
	"./profit_if_trade_open_earlier_later.png": 4625,
	"./profit_of_conflicting_symbols.png": 1061,
	"./profit_secure_payoff_from_reverting_trades.png": 2262,
	"./profit_when_sl_adjusted_vs_profit_when_not.png": 74,
	"./profit_with_against_st_mt_trend.png": 294,
	"./risk_after_losing_trades_open_trade.png": 9692,
	"./risk_after_losing_trades_per_trade.png": 4993,
	"./risk_per_trade_last_trades.png": 3570,
	"./spread_and_commission.png": 4994,
	"./trades_per_day_per_trade.png": 1324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1350;